// extracted by mini-css-extract-plugin
module.exports = {"list_product":"styles_list_product__2Uzc5","alert":"styles_alert__32xlC","searchquery":"styles_searchquery__7M1Ub"};